export * from './active-status.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/active-status/index.ts